<template>
  <dl class="browser-info" data-testid="logs-browser-info">
    <div v-for="row in rows" :key="row.label" class="browser-info__row">
      <dt class="browser-info__label">{{ row.label }}</dt>
      <dd class="browser-info__value">{{ row.value }}</dd>
    </div>
  </dl>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useLogsStore } from '@/modules/viewer/store/useLogsStore';

const { browserInfo } = storeToRefs(useLogsStore());

const rows = computed(() => [
  { label: 'User agent', value: browserInfo.value.userAgent },
  { label: 'Platform', value: browserInfo.value.platform },
  { label: 'Language', value: browserInfo.value.language },
  { label: 'Screen resolution', value: browserInfo.value.screenResolution },
  { label: 'Viewport size', value: browserInfo.value.viewportSize },
  { label: 'Timezone', value: browserInfo.value.timezone },
]);
</script>

<style scoped>
.browser-info {
  @apply flex flex-col p-4;
}

.browser-info__row {
  @apply py-2 border-b border-zinc-100 dark:border-zinc-700/60;
}

.browser-info__label {
  @apply text-xs font-semibold uppercase text-zinc-500 dark:text-zinc-400 mb-1;
}

.browser-info__value {
  @apply text-sm text-zinc-800 dark:text-zinc-200 break-words;
}
</style>
